import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './custom-box.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class CustomBox extends s {
    constructor() {
        super(...arguments);
        this.isRtl = false;
        this.containerClassNames = '';
    }
    render() {
        this.containerClassNames = getStyleClassNames({
            isRtl: this.isRtl,
        });
        return $ `<div class="custom-box ${this.containerClassNames}"><slot></slot></div>`;
    }
}
CustomBox.styles = css_248z;
__decorate([
    e({ type: Boolean })
], CustomBox.prototype, "isRtl", void 0);
customElements.define('custom-box', CustomBox);

export { CustomBox };
